<template>
  <div
    class="container container-xl margin-xl-top margin-xl-bottom l:margin-2xl-top relative">
    <div
      v-if="articleLayout === false"
      class="loading flex-middle flex-center"
      style="min-height: 50vh">
      <spinner :size="5"></spinner>
    </div>
    <page-title-block text="ag.article.blog.title" theme="lead-1" class="relative">
      <template #tools>
        <form-input
          v-model="filters.title"
          style="flex: 50%"
          type="text"
          icon="magnify"
          :apply-minimal-width="false"
          placeholder="ag.article.blog.filter.text.placeholder"
          :label="false"
          class="margin-remove"
          @update:modelValue="(newValue) => test(newValue)"></form-input>
        <form-input
          v-model="filters.type"
          style="flex: 50%"
          type="select"
          :apply-minimal-width="false"
          icon="sliders-alt-horizontal"
          placeholder="ag.article.blog.filter.type.placeholder"
          :list="[
            { value: 'all', label: 'ag.article.blog.filter.type.all' },
            { value: 'blog', label: 'ag.article.blog.filter.type.blog' },
            { value: 'newsFlash', label: 'ag.article.blog.filter.type.newsFlash' },
          ]"
          :label="false"
          class="margin-remove"></form-input>
        <!--v-if="isLoading"-->
      </template>
    </page-title-block>
    <div class="inline-bar-loader width-expand flex-middle flex-center relative" style="">
      <bar-loader
        v-if="isLoading"
        :size="5"
        :fixed="false"
        class="absolute-center width-expand"
        style="position: absolute; bottom: 0"></bar-loader>
    </div>

    <div v-if="articles" class="articles flex gap-max l:gap-2xl flex-wrap">
      <div
        v-for="(article, index) in articles"
        class="article-wrapper"
        :class="{ 'article-wrapper--major': index === 0 && pagination.start === 0 }">
        <article-item-intro
          class="article"
          :item="article"
          :is-major="index === 0 && pagination.start === 0">
        </article-item-intro>
      </div>
    </div>

    <div v-if="(!articles || articles.length === 0) && !isLoading">
      <h3>{{ tu("core.noItemsFound") }}</h3>
    </div>

    <pagination
      v-if="articles && !isLoading"
      v-model:pageSize="pagination.limit"
      v-model:currentPage="pagination.start"
      class="margin-2xl-top"
      :total-count="pagination.totalCount"></pagination>
  </div>
</template>

<script>
import ArticleItemIntro from "@/client/applications/agaloola/components/items/article/Intro.vue";
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import { useStore } from "vuex";
import { computed, reactive } from "vue";
import PageTitleBlock from "@/client/applications/agaloola/components/base/frameworks/we/AgPageTitleBlock";
import useDebounceComputed from "@/client/extensions/composition/asyncOperations/useDebounceComputed";

export default {
  components: {
    ArticleItemIntro,
    PageTitleBlock,
  },
  layout: "default",
  props: {},
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props, useStore());
    const { computedValue: computedSearchValue, isDebouncing: isSearchDebouncing } =
      useDebounceComputed(undefined, 500);

    const filters = reactive({
      type: "all",
      title: computedSearchValue,
    });

    return {
      useDebounceComputed,
      asyncOps,
      asyncOpsReady,
      asyncStatus,
      filters,
      computedSearchValue,
      isSearchDebouncing,
    };
  },
  meta: "ag.article.blog.pageTitle",
  data: function () {
    console.log("in data", this.useDebounceComputed);
    let pagination = {
      start: 0,
      limit: 4,
      totalCount: 0,
    };
    let ordering = {
      key: "manualDate",
      direction: "DESC",
    };
    return {
      articles: false,
      pagination: pagination,
      ordering,
      asyncData: {
        articles: {
          target: "agaloola/article",
          data: {
            filters: computed(() => this.filters),
            pagination: computed(() => this.pagination),
            ordering: computed(() => this.ordering),
          },
          options: {
            dataMutator(data) {
              console.log(data);
              pagination.totalCount = data.totalCount;
              return data.items;
            },
          },
        },
      },
    };
  },
  computed: {
    isLoading() {
      return this.isSearchDebouncing || this.asyncStatus.asyncDataLoading;
    },
  },
  methods: {
    test(a) {
      console.log("test", a);
    },
  },
  serverPrefetch() {
    console.log("await server prefetch on articles");
    return this.getSSRPrefetchPromise();
  },
};
</script>

<style scoped lang="scss">
.main-title h1 {
  font-size: calc(var(--font-max) * 2);
  line-height: calc(var(--font-max) * 1.65);

  @media (max-width: 767px) {
    font-size: calc(var(--font-max));
    line-height: calc(var(--font-max) * 1);
  }
}
.articles {
  @media (max-width: 767px) {
    max-width: 360px;
    margin-inline: auto;
  }
}

.article-wrapper {
  max-width: 400px;

  &--major {
    flex: 100%;
    max-width: 100%;
  }

  @media (max-width: 767px) {
    max-width: 100%;
  }

  .article {
    max-width: 100%;
  }
}

.inline-bar-loader {
  height: 3px;
  top: calc(-1 * var(--margin-xl));
  pointer-events: none;
}
</style>
